import ManageOperators from "./ManageOperators";

export default ManageOperators;